import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Small = makeShortcode("Small");
const DateUpdated = makeShortcode("DateUpdated");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "what-im-doing-now",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#what-im-doing-now",
        "aria-label": "what im doing now permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`What I’m doing Now`}</h2>
    <Small mdxType="Small">
  Last updated: <DateUpdated date={`2020-10-28`} small={`true`} mdxType="DateUpdated" />
    </Small>
    <h3 {...{
      "id": "work",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#work",
        "aria-label": "work permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Work`}</h3>
    <p>{`Working as a Web Developer for `}<a parentName="p" {...{
        "href": "https://www.karmarama.com/",
        "target": "_blank",
        "rel": "noopener"
      }}>{`Karmarama`}</a>{`, using a variety of
technologies.`}</p>
    <p>{`I’m evangelising the jamstack to anyone that will listen on the team
and we have used Gatsby in several projects now, `}<a parentName="p" {...{
        "href": "https://asi.style",
        "target": "_blank",
        "rel": "noopener"
      }}>{`asi.style`}</a>{` being one
of the first.`}</p>
    <p>{`I have estimated and delivered a project in Preact utilising Lottie
animations in a guided tour with action points to give more
information.`}</p>
    <p>{`Recently documented the migration plan of a project from a legacy
server and suggested the next iteration of the project.`}</p>
    <h3 {...{
      "id": "play",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#play",
        "aria-label": "play permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Play`}</h3>
    <p>{`I’m still playing Borderlands 3! With the Legendary collection on the
Switch I’m now playing Borderlands 2 again!!`}</p>
    <p>{`Due to COVID19 gym hasn’t been happening 😢`}</p>
    <hr></hr>
    {
      /* Links */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      